import { useQuery } from "@tanstack/react-query";

import { checkStatusAxios } from "../client/CatTrackAPI";
import { SeriesPoint } from "../data/Account";
import { useAxios } from "./AxiosContext";

interface CategorySeriesResponse {
  label: string;
  value: string;
}

export function useCategorySeries(category_id: string) {
  const axios = useAxios();

  const fetchCategories = (): Promise<SeriesPoint[]> => {
    const fromDate = "2023-01-01";
    const toDate = new Date().toISOString().split("T")[0];

    return (
      axios
        .get(`/api/categories/${category_id}/series/`, {
          params: {
            from_date: fromDate,
            to_date: toDate,
          },
        })
        .then(checkStatusAxios)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .then((series: any[]) =>
          series.map((raw: CategorySeriesResponse) => {
            return { label: raw.label, value: parseFloat(raw.value) };
          }),
        )
    );
  };

  return useQuery({
    queryKey: ["categorySeries", category_id],
    queryFn: fetchCategories,
    enabled: !!category_id,
  });
}
